// extracted by mini-css-extract-plugin
export default {"chipContent":"style_chipContent__0UQKw","headerWrapper":"style_headerWrapper__NZLVm","headerContent":"style_headerContent__b54Lu","contentWrapper":"style_contentWrapper__lBGwK"};